
import Typography from '@mui/material/Typography';
import './Leader.scss';
import PipeService from '../services/PipeService';
import classNames from 'classnames';
const LeaderComponent = ({ leader, className }) => {
    const { avatar } = PipeService.getInstance();
    
    return (
        <div className={classNames(['leader', className])}>
             <img src={avatar(leader.userId)} className='avatar' />

             <div className='leader-info'>
                <Typography variant="p" className="name" component="div">
                    {leader.firstName} {leader.lastName ? leader.lastName.charAt(0) : ''}.
                </Typography>
                <Typography className='score' variant="p" component="div">
                    {leader.formatted}
                </Typography>
            </div>
        </div>
    );
}
export default LeaderComponent;